import React from 'react'
import {
  Button,
  ModalDialog,
  ModalDialogHeader,
  ModalDialogBody,
  ModalDialogTitle,
  ModalDialogContent,
  ModalDialogCloseButton,
  ModalDialogNav,
  ModalDialogButtons,
  ModalDialogFooter,
} from '@vp/swan'
import { withTranslation } from 'react-i18next'
import { CallMeWidget } from '@vp/care-react-c2c'

import { CallMeButton } from './CallMeButton'
import EmailModal from './EmailModal'

import AnalyticsTracking from '../analytics/analytics'
import { useConfig } from '../../contexts/ConfigProvider'

const EmailPhoneCtaModal = (props) => {
  const { t, isModalOpen, closeModal, lng, tenant, locale, contactChannels, proadvantageType, handleError, callMeService, auth } = props
  const dataConfig = useConfig()
  const [isEmailModalOpen, setIsEmailModalOpen] = React.useState(false)

  const closeEmailModal = () => {
    setIsEmailModalOpen(false)
    AnalyticsTracking.trackEvent('Email Form Closed', {
      subject: 'Email Form Closed',
    })
  }

  const openEmailModal = () => {
    setIsEmailModalOpen(true)
    AnalyticsTracking.trackEventWithDetails('Button Clicked', {
      action: 'Button Clicked',
      category: 'Global Email',
      label: 'Email Confirmed - Callback Deflection',
      pageSection: 'Help Center',
      pageStage: 'Customer Care',
      pageName: 'Help Center:Email Form',
      eventDetail: callMeService ? 'BH;' : ' ',
    })
  }

  return (
    <>
      <ModalDialog isOpen={isModalOpen} onRequestDismiss={() => closeModal()} onlyRenderWhenOpen>
        <ModalDialogContent aria-labelledby="modal dialog button" p={{ xl: 9, lg: 9, md: 9, sm: 9, xs: '5' }}>
          <ModalDialogNav>
            <ModalDialogCloseButton accessibleText="Close" />
            {/* Close Button label text must be localized! */}
          </ModalDialogNav>
          <ModalDialogHeader>
            <ModalDialogTitle>{t(`${tenant}:email.email_phone_modal_title`, { lng })}</ModalDialogTitle>
          </ModalDialogHeader>
          <ModalDialogBody>{t(`${tenant}:email.email_phone_modal_description`, { lng })}</ModalDialogBody>
          <ModalDialogFooter>
            <ModalDialogButtons style={{ display: 'flex', justifyContent: 'flex-start' }}>
              <Button
                onClick={() => {
                  closeModal()
                  openEmailModal()
                }}
                skin="secondary"
                width="standard"
                size="standard"
                type="button"
                name="show_email_form"
                value="show_email_form"
              >
                {t(`${tenant}:email.buttons.email_phone_modal_email.title`, { lng })}
              </Button>

              <CallMeWidget
                tenant={props.tenant}
                locale={props.locale}
                pageName="Help Center:Email Form"
                pageStage="Customer Care"
                pageSection="Help Center"
                eventDetailPrefix={callMeService ? 'BH;' : ' '}
                errorHandler={handleError}
                onCloseWidgetCallback={closeModal}
                origin="Help-Center-Email"
              >
                <CallMeButton tenant={props.tenant} t={t} lng={lng} locale={props.locale} />
              </CallMeWidget>
            </ModalDialogButtons>
          </ModalDialogFooter>
        </ModalDialogContent>
      </ModalDialog>
      <EmailModal
        tenant={tenant}
        locale={locale}
        contactChannels={contactChannels}
        proadvantageType={proadvantageType}
        isModalOpen={isEmailModalOpen}
        closeModal={closeEmailModal}
        callMeService={callMeService}
        dataConfig={dataConfig}
        auth={auth}
      />
    </>
  )
}

export default withTranslation()(EmailPhoneCtaModal)
